import { Injectable } from '@angular/core';
import { LoginData } from '@klickdata/core/auth/src/auth/login.model';
import { AuthService } from '@klickdata/core/auth/src/token/auth.service';
import { ConfigService } from '@klickdata/core/config/src/config.service';
import { HttpErrorService } from '@klickdata/core/http/src/error/http-error.service';
import { RequestBuilderService } from '@klickdata/core/http/src/request/request-builder.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ActivationService {
    protected resourceUrl: string;

    constructor(
        protected builder: RequestBuilderService,
        protected auth: AuthService,
        protected config: ConfigService,
        protected error: HttpErrorService
    ) {
        this.resourceUrl = `${this.config.config.apiUrl}auth/activate`;
    }

    public activate(activation: LoginData): Observable<any> {
        return this.builder
            .post<any>(this.resourceUrl, activation)
            .request()
            .pipe(
                map(res => {
                    if (res.data.token) {
                        return this.auth.handleLogin(res, activation);
                    }
                    return res;
                }),
                catchError(err => this.error.handle(err))
            );
    }
}
